import EnglishTranslation from './en';
import JapaneseTranslation from './ja';

export { EnglishTranslation, JapaneseTranslation };

export default {
  ja: JapaneseTranslation,
  en: EnglishTranslation
};
